import api from "../../Environment";

/**
 * A-009A — Platform Availability API. React consumes only platformAvailabilityPayload.
 */

export async function fetchPlatformAvailability({ organizationSlug } = {}) {
  const params = {};
  if (organizationSlug) {
    params.organization_slug = organizationSlug;
  }
  const response = await api.postMethod("platform-availability", params);
  const body = response && response.data;
  if (!body || body.success === false) {
    throw new Error(
      (body && (body.error_message || body.error_messages)) ||
        "Unable to load platform availability"
    );
  }
  return body.data || { platforms: [], entity: {}, title: "", subtitle: "" };
}
